import { Session } from 'next-auth';
import { signIn } from 'next-auth/react';
import { FC, PropsWithChildren, useEffect } from 'react';
import {
  useInternalSession,
  useLiff,
  useMember
} from '../../providers/SessionProvider';
import { useLoading } from '../../providers/LoadingProvider';
import AthomeLayout from '../common/AthomeLayout';
import Unvailable from '../unvailable/Unvailable';
import NotLineBrowserError from '../notLineBrowserError/notLineBrowserError';
import { useIsCompanyDisabled } from '../../hooks/useIsCompanyDisabled';
import LiffLayout from '../../components/common/LiffLayout';

const Auth: FC<PropsWithChildren> = ({ children }) => {
  // if `{ required: true }` is supplied, `status` can only be "loading" or "authenticated"
  const { status, data: session } = useInternalSession();
  const { member } = useMember();
  const { setLoading } = useLoading();
  const isCompanyDisabled = useIsCompanyDisabled(member.companyId);
  const liff = useLiff();
  useEffect(() => {
    if (
      (session as Session & { error: string })?.error ===
      'RefreshAccessTokenError'
    ) {
      signIn(); // Force sign in to hopefully resolve error
    }
  }, [session]);

  useEffect(() => {
    setLoading(status === 'loading');
  }, [status]);

  switch (status) {
    case 'loading':
      return null;
    case 'authenticated':
      // ログイン中の会員IDが利用不可の会員リストの中にあったら、エラーページを表示する
      if (isCompanyDisabled) {
        return <AthomeLayout page={<Unvailable />} />;
      } else {
        return <>{children}</>;
      }
    default: // 'unauthenticated'のみの想定
      if (liff)
        // liffのURLの場合は下記を返却する
        return <LiffLayout page={<NotLineBrowserError />} />;
      else return <></>;
  }
};

export default Auth;
